import { render } from "./CreateContract.vue?vue&type=template&id=1799e7b4&scoped=true"
import script from "./CreateContract.vue?vue&type=script&lang=js"
export * from "./CreateContract.vue?vue&type=script&lang=js"

import "./CreateContract.vue?vue&type=style&index=0&id=1799e7b4&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1799e7b4"]])

export default __exports__